import { useNavigate } from "react-router-dom";
import styles from "./avaliacoes.module.css";
import BackIcon from "../../../components/BackIcon";
import BottomNav from "../../../components/BottomNav";
import { AuthContext } from "../../../context/AuthContext";
import { useContext } from "react";

export default function Avaliacoes() {
    const navigate = useNavigate();
    const { user } = useContext(AuthContext);

    function abrirLink(url) {
        if (!url) return;
        window.open(url, "_blank");
    }

    // TODO: substituir "rota" pelos links reais de cada avaliação
    const menus = [
        {
            titulo: "AutoAvaliação",
            descricao: "Avalie o seu próprio desempenho.",
            icone: "🙋",
            rota: `http://186.237.132.27:9033/m/?tipace=e&token=${user.toksim}&cpf=${user.cpffun}`
        },
        {
            titulo: "Avaliação de Pares",
            descricao: "Avalie o desempenho dos colegas da sua equipe.",
            icone: "🤝",
            rota: `http://186.237.132.27:9033/m/?tipace=c&token=${user.toksim}&cpf=${user.cpffun}`
        },
        {
            titulo: "Avaliação do Coordenador",
            descricao: "Avaliação realizada pelo seu coordenador.",
            icone: "🧑‍💼",
            rota: `http://186.237.132.27:9033/m/?tipace=d&token=${user.toksim}&cpf=${user.cpffun}`
        },
        {
            titulo: "Avaliação da Diretoria",
            descricao: "Avalie o desempenho da diretoria.",
            icone: "🏛️",
            rota: `http://186.237.132.27:9033/m/?tipace=6&token=${user.toksim}&cpf=${user.cpffun}`
        },
    ];

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <button className={styles.btnVoltar} onClick={() => navigate(-1)}><BackIcon /></button>
                <div className={styles.headerTexto}>
                    <h2>Faça sua Avaliação</h2>
                    <p>Escolha a avaliação que deseja responder</p>
                </div>
            </div>

            <div className={styles.grid}>
                {menus.map((item, index) => (
                    <div
                        key={index}
                        className={styles.card}
                        onClick={() => abrirLink(item.rota)}
                    >
                        <div className={styles.icon}>{item.icone}</div>

                        <div className={styles.info}>
                            <h4>{item.titulo}</h4>
                            <span>{item.descricao}</span>
                        </div>

                        <div className={styles.arrow}>›</div>
                    </div>
                ))}
            </div>
            <BottomNav />
        </div>
    );
}
